import { API_URL, isMockApi } from '../config';

import { HttpClient } from './http-client';

export interface LoginRequest {
    username: string;
    password: string;
}
export interface LoginResponse {
    token: string;
    brandId: number;
}
export const login = (httpClient: HttpClient) => (
    credentials: LoginRequest,
): Promise<LoginResponse> =>
    isMockApi
        ? new Promise(resolve => {
              console.log('[API] Login with', credentials);
              setTimeout(() => resolve({ token: 'my_test_token', brandId: 1 }), 1000);
          })
        : httpClient
            .post(`${API_URL}/v1/auth/login`, credentials)
            .then(res => res.data)
            .then(res => {
                if (!res.access_token) {
                    throw new Error('Invalid credentials');
                }

                if (!res.user.seller_id) {
                    throw new Error('Invalid credentials');
                }

                sessionStorage.setItem('userData', JSON.stringify(res.user))

                return {
                    token: res.access_token,
                    brandId: res.user.seller_id,
                };
            });

export const logout = (httpClient: HttpClient) => (): Promise<void> =>
    new Promise(resolve => {
        console.log('[API] Logout');
        sessionStorage.removeItem('userData')
        setTimeout(() => resolve(), 1000);
    });
